import React from "react";

import FileUploader from "../../FileUploader";

const UploadCv = () => {
  return <FileUploader.DragAndDrop accept=".pdf, .doc, .docx" buttonText="Choose file" inputName="upload_cv" />;
};

export default UploadCv;
